"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignRef = assignRef;
exports.useForkedRef = useForkedRef;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// Code logic in this file mostly copied from https://github.com/reach/reach-ui/blob/master/packages/utils/src/index.tsx
/*:: type Ref = React.Ref<any> | void;*/
// Passes or assigns an arbitrary value to a ref function or object.
function assignRef(ref /*: Ref*/, value /*: any*/) {
  if (ref == null) return;
  if (typeof ref === 'function') {
    ref(value);
  } else if ((0, _typeof2.default)(ref) === 'object') {
    ref.current = value;
  }
}

// Passes or assigns a value to multiple refs (typically a DOM node).
function useForkedRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return React.useMemo(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }
    return function (node /*: any*/) {
      refs.forEach(function (ref) {
        assignRef(ref, node);
      });
    };
  }, refs); // eslint-disable-line react-hooks/exhaustive-deps
}
//# sourceMappingURL=ref.js.map